import { validators } from '../../utils/validators';

const validate = (values, props) => {
    const errors = {};
    if (
        (!values.emailList || !values.emailList.length) &&
        (!values.registeredEmail || !values.registeredEmail.length)
    ) {
        errors.commonErrors = 'Please enter at-least one email ID';
        props.stopSubmit('notification-form', errors);
    } else {
        const emailListErrors = [];
        values.emailList.forEach((email, emailIndex) => {
            if (!email || !email.length) {
                emailListErrors[emailIndex] =
                    'Please enter an email or remove this field';
            } else {
                if (validators.EMAIL(email)) {
                    emailListErrors[emailIndex] =
                        'Please enter a valid email id';
                }
            }
        });

        errors.emailList = emailListErrors;
    }

    if (!values.mobileList || !values.mobileList.length) {
    } else {
        const mobileListErrors = [];
        values.mobileList.forEach((mobile, mobileIndex) => {
            if (!mobile || !mobile.length) {
                mobileListErrors[mobileIndex] =
                    'Please enter a phone number or remove this field';
            } else {
                if (validators.PHONE_NUMBER(mobile)) {
                    mobileListErrors[mobileIndex] =
                        'Please enter a valid phone number';
                }
            }
        });

        errors.mobileList = mobileListErrors;
    }

    if (!values.multipleEmails || !values.multipleEmails.length) {
    } else {
        const multipleEmailsErrors = [];

        values.multipleEmails.forEach((emailDetails, emailDetailsIndex) => {
            if (!emailDetails || !emailDetails.emailId) {
                multipleEmailsErrors[emailDetailsIndex] = {
                    emailId: 'Please enter atleast one email ID',
                };
            } else {
                if (validators.EMAIL(emailDetails.emailId)) {
                    multipleEmailsErrors[emailDetailsIndex] = {
                        emailId: 'Please enter a valid email Address',
                    };
                } else if (
                    !emailDetails?.config ||
                    !emailDetails?.config.length
                ) {
                    multipleEmailsErrors[emailDetailsIndex] = {
                        config: 'Please select atleast one configuration',
                    };
                }
            }
        });

        errors.multipleEmails = multipleEmailsErrors;
    }

    return errors;
};

export default validate;
